// 生命周期
const localStorageInterceptor = {
  // 读取数据前的拦截器
  beforeGet: () => {},
  // 读取数据后的拦截器
  afterGet: () => {},
  // 写入数据前的拦截器
  beforeSet: () => {},
  // 写入数据后的拦截器
  afterSet: () => {},
};

// 拦截器
const basicStorage = {
  getItem: key => {
    localStorageInterceptor.beforeGet(key);
    const value = localStorage.getItem(`${process.env.VUE_APP_STORAGETAG}-${key}`);
    localStorageInterceptor.afterGet(key, value);
    return value;
  },
  setItem: (key, value) => {
    localStorageInterceptor.beforeSet(key, value);
    localStorage.setItem(`${process.env.VUE_APP_STORAGETAG}-${key}`, value);
    localStorageInterceptor.afterSet(key, value);
  },
  removeItem: key => {
    localStorageInterceptor.beforeSet(key, null);
    localStorage.removeItem(`${process.env.VUE_APP_STORAGETAG}-${key}`);
    localStorageInterceptor.afterSet(key, null);
  },
};

export default basicStorage;
